import { Component, Inject, OnInit } from "@angular/core";
import { SaveQuoteEmailReferralService } from "../saved-quotes/services/save-quote-email-referral.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SaveQuoteEmailReferralModalArgs, ModalFieldConfigs } from "../saved-quotes/interfaces/save-quote-email-referral.interface";
import { Email } from "../interfaces/email.interface";
import { AbstractControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { EmailValidatorService } from "../../shared/services/email-validator.service";

interface EmailFormControls {
  customerEmailAddress: AbstractControl,
  clientName?: AbstractControl, 
  agency?: AbstractControl,
  agencyNumber?: AbstractControl,
  npn?: AbstractControl,
  zipCode?: AbstractControl,
  county?: AbstractControl,
  state?: AbstractControl,
  agentNotes?: AbstractControl
}

interface EmailFormControlsAsJson {
  customerEmailAddress: string,
  clientName?: string, 
  agency?: string,
  agencyNumber?: string | number,
  npn?: string | number,
  zipCode?: string | number,
  county?: string,
  state?: string,
  agentNotes?: string
}

@Component({
  selector: "app-save-quote-email-referral-modal",
  templateUrl: "./save-quote-email-referral-modal.component.html",
  styleUrl: "./save-quote-email-referral-modal.component.scss",
  standalone: false
})

export class SaveQuoteEmailReferralModalComponent implements OnInit {
  
  enableEmailForm: boolean;
  saveQuoteEmailPayload: Email;
  emailTriggerIsPending: boolean = false;
  emailForm: UntypedFormGroup;

  fieldsMap: ModalFieldConfigs[];
  
  sentEmail: boolean = false;
  showCloseWarning: boolean = false;
  emailSuccessStatusMessage: string; 

  constructor(
    private saveQuoteEmailReferralService: SaveQuoteEmailReferralService,
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<SaveQuoteEmailReferralModalComponent>,
    private matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: SaveQuoteEmailReferralModalArgs
  ){
    this.emailForm = this.fb.group({
      customerEmailAddress: this.fb.control(null, [
        Validators.required,
        EmailValidatorService.createEmailValidator(),
        Validators.maxLength(75)]),
      clientName: this.fb.control(null, [
        Validators.maxLength(60)
      ]),
      agentNotes: this.fb.control(null, [
        Validators.maxLength(500)
      ])
    })
  }

  async ngOnInit() {
    if(this.data.additionalModalFields){
      for(const index in this.data.additionalModalFields){
        this.emailForm.addControl(
          index,
          this.fb.control(null, [])
        );
      }
    }
    this.emailSuccessStatusMessage = this.data?.defaultFieldData?.emailSuccessStatusMessage ?? "Email Sent!"  }

  async triggerEmail(form: FormGroup){
    this.emailForm.markAllAsDirty();
    if(this.emailForm.valid){
      this.emailTriggerIsPending = true;
      await this.saveQuoteEmailReferralService.sendEmail(form, this.data.applicationRecord, this.data.quoteType, this.data.consumerDocumentUploadReturnUrl);
      this.matSnackBar.open(this.emailSuccessStatusMessage, 'OK', {
        duration: 3000,
        panelClass: 'positive-panel-class'
      });
      this.emailTriggerIsPending = false;
      this.dialogRef.close();
    }
  }
  
  get formControls(): EmailFormControls {
    return this.emailForm.controls as unknown as EmailFormControls;
  }

  get formControlsAsJson(): EmailFormControlsAsJson {
    return this.emailForm.value as unknown as EmailFormControlsAsJson;
  }

  checkIfSentEmail(){
    if(this.emailForm.dirty && this.showCloseWarning === false){
      this.showCloseWarning = true;
    } else {
      this.dialogRef.close();
    }
  }
}